import { render, staticRenderFns } from "./FlowList.vue?vue&type=template&id=71cedcce&scoped=true"
import script from "./FlowList.vue?vue&type=script&lang=js"
export * from "./FlowList.vue?vue&type=script&lang=js"
import style0 from "./FlowList.vue?vue&type=style&index=0&id=71cedcce&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71cedcce",
  null
  
)

export default component.exports